<template>
    <div v-redirect-if-no-permission:MANAGE_TRANSACTION>
        <loading-component v-model="loading"></loading-component>
        <DataTable url="bonus_request" :enable-add="false" :fields-hidden-main="['approved', 'account_id', 'updated_at', 'requester_user_id', 'handler_user_id']"
                   :enable-delete="false" :enable-edit="false" :actions-extra-main="actions"
                   title="Bonus Requests" :key="cnt" :conditional-action="conditionalActions"></DataTable>
    </div>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";
    import moment from "moment";
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        name: "BonusRequests",
        components: {LoadingComponent, DataTable},
        data() {
            return {
                loading: false,
                cnt: 0
            }
        },
        computed: {
            conditionalActions() {
                return {
                    approve: item => item.approved === null,
                    reject: item => item.approved === null
                }
            },
            actions() {
                if (!this.hasPermission('MANAGE_BONUS_REQUEST')) {
                    return {};
                }
                return {
                    approve: {
                        title: "Approve",
                        color: 'primary',
                        action: async (item) => {
                            this.loading = true;
                            this.axios.put(`bonus_request/${item.id}/approve`)
                                .then(() => {
                                    window.getApp.$emit("SHOW_TOAST", "Approved", "green")
                                    this.cnt++
                                })
                                .catch(err => {
                                    try {
                                        if (err.response.data.message) {
                                            window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red", ['center', 'top']);
                                        } else {
                                            window.getApp.$emit("SHOW_TOAST", err.message, "red", ['center', 'top']);
                                        }
                                    } catch (e) {
                                        console.log(err.message, e.message);
                                    }
                                }).finally(() => this.loading = false);
                        }
                    },
                    reject: {
                        title: "Reject",
                        color: 'red',
                        action: async (item) => {
                            this.loading = true;
                            this.axios.put(`bonus_request/${item.id}/reject`)
                                .then(() => {
                                    window.getApp.$emit("SHOW_TOAST", "Approved", "green")
                                    this.cnt++
                                })
                                .catch(err => {
                                    try {
                                        if (err.response.data.message) {
                                            window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red", ['center', 'top']);
                                        } else {
                                            window.getApp.$emit("SHOW_TOAST", err.message, "red", ['center', 'top']);
                                        }
                                    } catch (e) {
                                        console.log(err.message, e.message);
                                    }
                                }).finally(() => this.loading = false);
                        }
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>